import { render, staticRenderFns } from "./MicroscopyView.vue?vue&type=template&id=1f781cb0"
import script from "./MicroscopyView.vue?vue&type=script&lang=js"
export * from "./MicroscopyView.vue?vue&type=script&lang=js"
import style0 from "./MicroscopyView.vue?vue&type=style&index=0&id=1f781cb0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports